<template>
  <div class="container flex" style="margin-bottom: 20px;margin-top: 15px;">
    <div>
      <left></left>
    </div>
    <div class="flex1" style="margin-left: 20px;">
      <right :title="title" :list="list" :questionsStatus="questionsStatus" @initData="getData"></right>
    </div>

  </div>
</template>

<script>
import left from './left.vue'
import right from './examlist.vue'

export default {
  name: 'Footer',
  components: {
    left,
    right,
  },
  data () {
    return {
      data: '',
      title: '章节练习',
      pageNo: 1,
      pageSize: 100,
      questionsStatus: 3,
      list: []
    }
  },
  methods: {
    getData () {
      let data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        questionsStatus: this.questionsStatus,
      };
      this.$axios.get(this.$common.testPaper_exercisesList, { params: data }).then((res) => {
        if (res.data.code == 1) {
          this.list = res.data.data.list;
        }
        else {
          alert(res.data.msg)
        }
      })
    }
  },
  created () {
    this.getData()
  },
  watch: {
    // 利用watch方法检测路由变化：
    '$route': function (to, from) {
      // 拿到目标参数 to.query.id 去再次请求数据接口
      this.loadPageData(to.query.id)
    }
  }
}
</script>

<style scoped>
.live {
  border-left: none;
  border-right: none;
  border-top: none;
}
</style>



// WEBPACK FOOTER //
// src/components/homeworklist.vue